export default function () {
	return {
		address: [],
		birthday: '',
		email: '',
		full_name: ''
	}
}
